module.exports = __webpack_public_path__ + "media/images/partners/1_ucf-6a1b85fd0bb4b4f86f03896f1e29d445.png";